module.exports = __webpack_public_path__ + "media/images/bp_ic-8ed9d2abbfb584391f00ab3a247af2d0.svg";